<template>   
      <el-tabs class="powerOver" v-model="activeName">
        <el-tab-pane label="能源走势" name="1">
          <Trend v-if="activeName=='1'"></Trend>
        </el-tab-pane>
        <el-tab-pane label="能源结构" name="2">
          <Structure v-if="activeName=='2'"></Structure>
        </el-tab-pane>
        <el-tab-pane label="重点用能设备" name="3">
          <ForusDevice v-if="activeName=='3'"></ForusDevice>
        </el-tab-pane>
        <el-tab-pane label="安全提示" name="4">
          <Save v-if="activeName=='4'"></Save>
        </el-tab-pane>
        <el-tab-pane label="实时状态" name="5">
          <RealTime v-if="activeName=='5'"></RealTime>
        </el-tab-pane>
        <el-tab-pane label="全年碳排放指标" name="6">
          <CarbonTarget v-if="activeName=='6'"></CarbonTarget>
        </el-tab-pane>
        <el-tab-pane label="减排进度及走势" name="7">
          <LessPower v-if="activeName=='7'"></LessPower>
        </el-tab-pane>
        <el-tab-pane label="能源优化投入" name="8">
          <PowerNew v-if="activeName=='8'"></PowerNew>
        </el-tab-pane>
        <el-tab-pane label="能源优化成效" name="9">
          <PowerEffect v-if="activeName=='9'"></PowerEffect>
        </el-tab-pane>
        <el-tab-pane label="能源指标" name="10">
          <PowerTarget v-if="activeName=='10'"></PowerTarget>
        </el-tab-pane>
        <el-tab-pane label="行业对标" name="11">
          <TreadOther v-if="activeName=='11'"></TreadOther>
        </el-tab-pane>
        <el-tab-pane label="能源损耗" name="12">
          <PowerLoss v-if="activeName=='12'"></PowerLoss>
        </el-tab-pane>
        <el-tab-pane label="投产比" name="13">
          <PutIntoDB v-if="activeName=='13'"></PutIntoDB>
        </el-tab-pane>
        <el-tab-pane label="昨日用能" name="14">
          <LastPower v-if="activeName=='14'"></LastPower>
        </el-tab-pane>
        <el-tab-pane label="采集设备在线率" name="15">
          <OnlineRate v-if="activeName=='15'"></OnlineRate>
        </el-tab-pane>
        <el-tab-pane label="变压器负载" name="16">
          <TransformerLoad v-if="activeName=='16'"></TransformerLoad>
        </el-tab-pane>
        <el-tab-pane label="本月需量分析" name="17">
          <MonthAnalye v-if="activeName=='17'"></MonthAnalye>
        </el-tab-pane>
      </el-tabs>
</template>

<script>
import Trend from './powerMain/trend'
import Structure from './powerMain/structure'
import ForusDevice from './powerMain/forusDevice'
import Save from './powerMain/savePoint'
import RealTime from './powerMain/realTime'
import CarbonTarget from './powerMain/carbonEmission'
import LessPower from './powerMain/lessPoweTrend'
import PowerNew from './powerMain/powerNewPut'
import PowerEffect from './powerMain/powerEffect'
import PowerTarget from './powerMain/powerTarget'
import TreadOther from './powerMain/treadOther'
import PowerLoss from './powerMain/powerLoss'
import PutIntoDB from './powerMain/putIntoDB'
import LastPower from './powerMain/lastPower'
import OnlineRate from './powerMain/onlineRate'
import TransformerLoad from './powerMain/transformerLoad'
import MonthAnalye from './powerMain/monthAnalye'
export default {
  components:{
    Trend,
    Structure,
    ForusDevice,
    Save,
    RealTime,
    CarbonTarget,
    LessPower,
    PowerNew,
    PowerEffect,
    PowerTarget,
    TreadOther,
    PowerLoss,
    PutIntoDB,
    LastPower,
    OnlineRate,
    TransformerLoad,
    MonthAnalye,
  },
  data() {
      return {
        activeName: '1'
      }
  },
  mounted() {
  },
  methods: {
    // handleClick(tab, event) {
    //   console.log(tab, event);
    // }
  }
}
</script>

<style lang="less" scoped>
.powerOver {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
<style lang="less">
.powerOver { height: 100%; overflow-y: auto;
  .trend-title{ display: inline-block; width: 6rem; text-align: right; height: 1.8rem; padding:0 .8rem; line-height: 1.8rem; font-size: .8rem; background: #3570ff;}
  .last-save{ text-align: left; margin-bottom: 1rem;}
}
</style>